module.exports = __webpack_public_path__ + "emp-tweaked-lg.png?7f5ecd58114059795b0704599f1fedf4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/emp-tweaked-lg.png
// module id = 186
// module chunks = 0